var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useEffect } from 'react';
import store from 'store';
import { LoadingBounce } from '@michelin/acid-components';
import { getCacheProfile, setCacheProfile, } from '../../helpers/secureCache';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
import Oauth from '../../providers/Auth0Provider/Auth0Provider';
import { API_PROFILE } from '../../helpers/api';
import { logger, loggerError, loggerOk } from '../../helpers/Log';
import { getTranslations } from '../../request/getTranslations';
import { Languages } from '../../types/Languages';
import { DEVELOPMENT_MODE } from '../../constants/constants';
import i18n from '../../translations/CentralTranslation';
import { useCheckSession } from '../../hooks/useCheckSession';
import { AuthContext } from '../../authContext/AuthContext';
export var Profile = function (_a) {
    var redirect = _a.redirect, redirectToPreviousRoute = _a.redirectToPreviousRoute, onLogin = _a.onLogin;
    var contextValue = useContext(CentralProviderContext);
    var authResult = useContext(AuthContext).authResult;
    var accessToken = (authResult || {}).accessToken;
    var checkSession = useCheckSession();
    var urlParams = new URLSearchParams(window.location.search);
    // For Change Password page (to respect the origin app language and avoid rendering the page in the language selected in central-ui)
    var language = urlParams.get('language');
    function setProfile(profile, cache) {
        loggerOk('success profile', profile);
        var userId = profile.auth0['https://misp-solutions.com/userId'];
        var centralProfile = __assign(__assign({}, profile), { userRole: profile.auth0['https://misp-solutions.com/userRole'], auth0: {
                sub: profile.auth0.sub,
                nickname: profile.auth0.nickname,
                picture: profile.auth0.picture,
                updated_at: profile.auth0.updated_at,
                name: profile.auth0['https://misp-solutions.com/name'],
                email: profile.auth0['https://misp-solutions.com/email'],
                customerNumber: profile.auth0['https://misp-solutions.com/customerNumber'],
                userRole: profile.auth0['https://misp-solutions.com/userRole'],
                userId: userId,
            } });
        contextValue.setCentralProfile(centralProfile);
        setTimeout(function () {
            if (!redirectToPreviousRoute) {
                if (onLogin)
                    onLogin(redirect);
            }
            else {
                var forceRedirect = sessionStorage.getItem('forceRedirect');
                var redirectURL = forceRedirect || sessionStorage.getItem('redirect!') || sessionStorage.getItem('redirect');
                sessionStorage.removeItem('forceRedirect');
                sessionStorage.removeItem('redirect');
                sessionStorage.removeItem('redirect!');
                var cleanHash = redirectURL && String(redirectURL).charAt(0) === '#' ? "/".concat(redirectURL) : redirectURL;
                if (onLogin) {
                    onLogin(cleanHash || redirect);
                }
                else if (forceRedirect) {
                    // Redirecting in case onLogin is not defined but we need to redirect
                    window.location.pathname = forceRedirect;
                }
            }
        });
        if (cache) {
            logger('Adding centralProfile to cache');
            setCacheProfile(JSON.stringify(centralProfile));
        }
        var storeKey = store.get("language_".concat(contextValue.application, "_").concat(profile.uid));
        var getPossibleLanguage = function () {
            var allowedLanguages = contextValue.allowedLanguages;
            if (allowedLanguages.includes(storeKey))
                return storeKey;
            if (allowedLanguages.includes(profile.profile.language))
                return profile.profile.language;
            return allowedLanguages[0] || Languages.EN_US;
        };
        var currentLanguage = language || getPossibleLanguage();
        contextValue.setCurrentLanguage(currentLanguage);
        // translations
        if (contextValue.disableTranslationsManager) {
            i18n.changeLanguage(currentLanguage || 'en_US');
            contextValue.setTranslationLoaded(true);
            return;
        }
        if (accessToken) {
            getTranslations({
                application: contextValue.application,
                language: currentLanguage,
                access_token: accessToken,
                setTranslationLoaded: contextValue.setTranslationLoaded,
            });
        }
    }
    function getCentralProfile() {
        try {
            logger('requesting profile', API_PROFILE);
            fetch("".concat(API_PROFILE, "?application=").concat(contextValue.application, "&app_key=").concat(contextValue.application, "&expires_in=").concat(authResult === null || authResult === void 0 ? void 0 : authResult.expiresIn), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: "Bearer ".concat(accessToken),
                    'JWT-Auth': "".concat(authResult === null || authResult === void 0 ? void 0 : authResult.idToken),
                },
            })
                .then(function (response) {
                var json = response.json();
                logger('get profile', json);
                return json;
            })
                .then(function (profileResponse) {
                if (profileResponse && profileResponse.error) {
                    loggerError('error profile', profileResponse);
                    throw new Error(profileResponse.error);
                }
                else {
                    // set profile
                    setProfile(profileResponse, DEVELOPMENT_MODE);
                }
            })
                .catch(function (error) {
                loggerError('fail API_PROFILE', API_PROFILE);
                loggerError(error);
                Oauth.logout();
            });
        }
        catch (error) {
            loggerError('fail API_PROFILE', API_PROFILE);
            loggerError(error);
            Oauth.logout();
        }
    }
    useEffect(function () {
        logger('Setting check session interval');
        checkSession();
        var cachedCentralProfile = getCacheProfile();
        if (cachedCentralProfile) {
            logger('Getting centralProfile from cache');
            setProfile(cachedCentralProfile);
        }
        else {
            getCentralProfile();
        }
    }, []);
    return (React.createElement("div", { style: {
            width: '100%',
            height: '100%',
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        } },
        React.createElement(LoadingBounce, { style: { height: '100vh' } })));
};
//# sourceMappingURL=Profile.js.map